import { useEffect, useState } from "react";
import CardProjectFiche from "./CardProjectFiche";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";
import { iconsDetailsProyect } from "../../../../assets/icons/detailsProject";
import { ProgressIndicator } from "../../../../components/ProgressIndicator/ProgressIndicator";
import { truncateFloat } from "../../../../helpers/generalHelper";


const CardProgressBar = ({ isSuperAdmin, isAdmin, tableIndication, activeModalDetailsProject }) => {
    const [statusBar, setStatusBar] = useState([]);

    useEffect(() => {
        const areasInformation = {
            planning: { name: "Planeación", color: "#940bab", field: "planning", tracked: 0, budget: 0 },
            design: { name: "Diseño UI/UX", color: "#FF4081", field: "design", tracked: 0, budget: 0 },
            modeling: { name: "Arte 3D", color: "#7C4DFF", field: "modeling", tracked: 0, budget: 0 },
            unity: { name: "Programación Unity", color: "#02BCD4", field: "unity", tracked: 0, budget: 0 },
            web: { name: "Programación Web", color: "#2ECD6F", field: "web", tracked: 0, budget: 0 },
            testing: { name: "Testing", color: "#9cc", field: "testing", tracked: 0, budget: 0 },
        };
        tableIndication.forEach((area) => {
            const { field } = area;
            areasInformation[field] = { ...area };
        });

        setStatusBar(Object.values(areasInformation));
    }, [tableIndication]);

    return (
        <CardProjectFiche
            title="Horas Acumuladas Totales / Horas presupuesto"
            className="overflow-x-scroll scroll-project-details"
            enableButtonExtra={isSuperAdmin || isAdmin}
            buttonExtra={
                <div
                    onClick={() => {
                        activeModalDetailsProject(typeForDetailsProyect.hrsProjectDetails);
                    }}
                    className="h-full w-[15px] cursor-pointer"
                >
                    <img className="h-full w-full object-contain" src={iconsDetailsProyect.editbutton} alt="edit" />
                </div>
            }
        >
            <div className="h-[250px] md:h-[250px]">
                <div className="h-full grid gap-4 ">
                    {statusBar.map((hrs, index) => (
                        <div key={`${index}-progressindicator`} className="h-[24px] inline-flex items-center gap-4">
                            <div className="w-[80px] h-full">
                                <p className="text-[12px]">{hrs.name}</p>
                            </div>
                            <div className="w-[calc(100%-80px-100px-80px)] h-full pr-4">
                                <ProgressIndicator
                                    percent={truncateFloat(
                                        hrs.budget === 0 ? hrs.tracked * 10 : hrs.tracked === 0 ? 0 : (hrs.tracked * 100) / hrs.budget
                                    )}
                                    propsProgress={{ strokeWidth: 10, trailColor: "#ccc", strokeColor: hrs.color }}
                                />
                            </div>
                            <div className="w-[100px] h-full">
                                <p className="text-[12px] text-right">
                                    {truncateFloat(hrs.tracked)}/{truncateFloat(hrs.budget)} Hrs
                                </p>
                            </div>
                            <div className="w-[80px] h-full flex gap-2 text-right justify-end">
                                <p className="text-[12px]">{hrs.subtract || 0}</p>
                                <p className="text-[12px] font-bold">H R</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </CardProjectFiche>
    );
};

export default CardProgressBar;
